angular.module('ihestiaMenuClipboard', [
  'ihestia-menu-templates-app'
]);